import { IUserOrder } from 'pages/ExpirationInfo/types'
import ContentLoader from 'react-content-loader'
import { useSelector } from 'react-redux'
import { RootState } from 'store/modules/rootReducer'
import { ProductsEnum } from '../ExpirationInfoContent'
import * as S from './styles'

interface IExpirationListMobileProps {
  id?: string
  userOrders: IUserOrder[]
  isLoading: boolean
  getListIcon: (order: IUserOrder) => string
}

const ExpirationListMobile: React.FC<IExpirationListMobileProps> = ({
  id,
  userOrders,
  isLoading,
  getListIcon,
}) => {
  const { isDarkMode } = useSelector((state: RootState) => state.theme)

  const loaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <S.MobileList id={id}>
      {isLoading && (
        <ContentLoader width={'100%'} height={'600px'} {...loaderProps}>
          <rect x="0" y="0" rx="3" ry="3" width="100%" height="250" />
          <rect x="0" y="270" rx="3" ry="3" width="100%" height="250" />
        </ContentLoader>
      )}
      {!isLoading &&
        userOrders !== null &&
        userOrders.map((order) => {
          return (
            <S.ListContent key={order._id}>
              <div className="cardHeader">
                <figure className="cardIcon">
                  <img src={getListIcon(order)} alt={`Logo ${order.name}`} />
                </figure>
                <span>{ProductsEnum[order.type]}</span>
              </div>
              <div className="cardBody">
                <p>{order.name}</p>
              </div>
              <div className="cardFooter">
                <div>
                  <span>Data da compra</span>
                  <span>{new Date(order.acceptedAt).toLocaleDateString('en-GB')}</span>
                </div>
                <div>
                  <span>Data de expiração</span>
                  <span>
                    {order.name === 'Assinatura Vitalícia' ||
                    order.name === 'Assinatura Vitalícia Premium'
                      ? 'Ilimitado'
                      : order.finalDate
                      ? new Date(order.finalDate).toLocaleDateString('en-GB')
                      : 'A definir'}
                  </span>
                </div>
              </div>
            </S.ListContent>
          )
        })}
      {!isLoading && (!userOrders || userOrders.length === 0) && (
        <div className="noOrders">Você não possui nenhum conteúdo adquirido.</div>
      )}
    </S.MobileList>
  )
}

export default ExpirationListMobile
